import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { useDispatch, useSelector } from 'react-redux';
import {
  doBulkDeleteBusiness,
  doShowLogs,
} from 'state/bulkDeleteBusiness/actions';
import MainPage from 'pages/BulkDeleteBusiness/MainPage';
import ProcessingPage from 'pages/BulkDeleteBusiness/ProcessingPage';

function getBusinessIdsArray(strArray) {
  return [...new Set(strArray.split('\n'))]
    .map(bId => parseInt(bId, 10))
    .filter(bId => !Number.isNaN(bId));
}

function BulkDeleteBusiness() {
  const dispatch = useDispatch();

  const onSubmit = values => {
    dispatch(doBulkDeleteBusiness(getBusinessIdsArray(values.business_ids)));
  };

  const isProcessing = useSelector(
    state => state.bulkDeleteBusiness.isProcessing
  );

  return (
    <>
      <SemanticToastContainer />
      <h1>Bulk Delete Business</h1>
      <br />
      {isProcessing ? (
        <ProcessingPage />
      ) : (
        <MainPage
          onSubmit={onSubmit}
          onShowLogButtonClicked={() => dispatch(doShowLogs())}
        />
      )}
    </>
  );
}

export default BulkDeleteBusiness;
